/**
 * WorkflowStatusChip — the uppercase tinted status pill shared by the
 * TraceDrawer Jobs ledger (ConversationJobs) and the Workflow timeline
 * (TraceHierarchy), so both lenses render identical chips for the same
 * underlying job state. (design-contract §2/§3)
 *
 * Tints (all via chariot tokens, theme-aware, never raw hex):
 *  - running  → brand-primary tint  ("Running")
 *  - queued   → neutral/stroke tint  ("Queued")
 *  - pass     → success/green tint   ("Complete" in Jobs, "Pass" in Workflow)
 *  - fail     → error/critical tint  ("Failed" in Jobs, "Fail" in Workflow)
 */

export type WorkflowChipStatus = 'running' | 'queued' | 'pass' | 'fail';

const styles: Record<WorkflowChipStatus, string> = {
  running:
    'bg-chariot-brand-primary/12 text-chariot-brand-primary border-chariot-brand-primary/35',
  queued:
    'bg-chariot-background-secondary text-chariot-text-tertiary border-chariot-stroke',
  pass: 'bg-chariot-stroke-light-green/10 text-success border-chariot-stroke-light-green/30',
  fail: 'bg-chariot-stroke-critical/12 text-error border-chariot-stroke-critical/40',
};

export function WorkflowStatusChip({
  status,
  label,
}: {
  status: WorkflowChipStatus;
  label: string;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold tracking-wide uppercase ${styles[status]}`}
    >
      {label}
    </span>
  );
}

export default WorkflowStatusChip;
